// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Rect$SmartcutsMacros = require("../../../Rect.bs.js");
var CustomMap$SmartcutsMacros = require("../../../CustomMap.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../../bs-utils/src/DeccoUtils.bs.js");
var StateMachine$SmartcutsMacros = require("../../../StateMachine.bs.js");
var CommandContext$SmartcutsMacros = require("../../../CommandContext.bs.js");
var GoogleSheetTypes$SmartcutsMacros = require("../../../GoogleSheetTypes.bs.js");
var PendingCommandInfo$SmartcutsMacros = require("../../../PendingCommandInfo.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("../../../commands/GoogleSheetsCommand.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../ContentScript__StateMachine__Shared__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = require("./ContentScript__StateMachine__RecordingMode__Shared.bs.js");

function state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  if (typeof v === "number") {
    return ["Init"];
  }
  switch (v.TAG | 0) {
    case /* EditingGoogleSheets */0 :
        return [
                "EditingGoogleSheets",
                editingGoogleSheets_encode(encoder_domEvent, v._0)
              ];
    case /* AwaitingPendingRequestsToFinishAndExit */1 :
        return [
                "AwaitingPendingRequestsToFinishAndExit",
                editingGoogleSheets_encode(encoder_domEvent, v._0),
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                      }), v._1)
              ];
    case /* Exiting */2 :
        return [
                "Exiting",
                exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* Exited */3 :
        return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                      }), v._0)
              ];
    
  }
}

function exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

function exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
          return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict._0, "allExitReasons"), null));
  if (allExitReasons.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              allExitReasons: allExitReasons._0
            }
          };
  }
  var e = allExitReasons._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".allExitReasons" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function editingGoogleSheets_decode(decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheets = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheets"), null));
    if (sheets.TAG === /* Ok */0) {
      var editingInCell = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "editingInCell"), null));
      if (editingInCell.TAG === /* Ok */0) {
        var numPendingRequests = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPendingRequests"), null));
        if (numPendingRequests.TAG === /* Ok */0) {
          var disconnectMutationObserver = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "disconnectMutationObserver"), null));
          if (disconnectMutationObserver.TAG === /* Ok */0) {
            var stopListeningToCanvas = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stopListeningToCanvas"), null));
            if (stopListeningToCanvas.TAG === /* Ok */0) {
              var expectPaste = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectPaste"), null));
              if (expectPaste.TAG === /* Ok */0) {
                var googleAuthCallback = Decco.optionFromJson((function (param) {
                        return googleAuthCallback_decode(decoder_domEvent, param);
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "googleAuthCallback"), null));
                if (googleAuthCallback.TAG === /* Ok */0) {
                  var removeListenersPreventingUserInteraction = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "removeListenersPreventingUserInteraction"), null));
                  if (removeListenersPreventingUserInteraction.TAG === /* Ok */0) {
                    var sheetUpdateTriggerCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetUpdateTriggerCount"), null));
                    if (sheetUpdateTriggerCount.TAG === /* Ok */0) {
                      var mostRecentTriggerThatReceivedSheetUpdate = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mostRecentTriggerThatReceivedSheetUpdate"), null));
                      if (mostRecentTriggerThatReceivedSheetUpdate.TAG === /* Ok */0) {
                        var rectForCommandKey = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rectForCommandKey"), null));
                        if (rectForCommandKey.TAG === /* Ok */0) {
                          var expectCellValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectCellValue"), null));
                          if (expectCellValue.TAG === /* Ok */0) {
                            var pendingCommandKey = Decco.optionFromJson(PendingCommandInfo$SmartcutsMacros.key_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pendingCommandKey"), null));
                            if (pendingCommandKey.TAG === /* Ok */0) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: {
                                        spreadsheetId: spreadsheetId._0,
                                        sheets: sheets._0,
                                        editingInCell: editingInCell._0,
                                        numPendingRequests: numPendingRequests._0,
                                        disconnectMutationObserver: disconnectMutationObserver._0,
                                        stopListeningToCanvas: stopListeningToCanvas._0,
                                        expectPaste: expectPaste._0,
                                        googleAuthCallback: googleAuthCallback._0,
                                        removeListenersPreventingUserInteraction: removeListenersPreventingUserInteraction._0,
                                        sheetUpdateTriggerCount: sheetUpdateTriggerCount._0,
                                        mostRecentTriggerThatReceivedSheetUpdate: mostRecentTriggerThatReceivedSheetUpdate._0,
                                        rectForCommandKey: rectForCommandKey._0,
                                        expectCellValue: expectCellValue._0,
                                        pendingCommandKey: pendingCommandKey._0
                                      }
                                    };
                            }
                            var e = pendingCommandKey._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".pendingCommandKey" + e.path,
                                      message: e.message,
                                      value: e.value
                                    }
                                  };
                          }
                          var e$1 = expectCellValue._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".expectCellValue" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                  }
                                };
                        }
                        var e$2 = rectForCommandKey._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".rectForCommandKey" + e$2.path,
                                  message: e$2.message,
                                  value: e$2.value
                                }
                              };
                      }
                      var e$3 = mostRecentTriggerThatReceivedSheetUpdate._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".mostRecentTriggerThatReceivedSheetUpdate" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                              }
                            };
                    }
                    var e$4 = sheetUpdateTriggerCount._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".sheetUpdateTriggerCount" + e$4.path,
                              message: e$4.message,
                              value: e$4.value
                            }
                          };
                  }
                  var e$5 = removeListenersPreventingUserInteraction._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".removeListenersPreventingUserInteraction" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                          }
                        };
                }
                var e$6 = googleAuthCallback._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".googleAuthCallback" + e$6.path,
                          message: e$6.message,
                          value: e$6.value
                        }
                      };
              }
              var e$7 = expectPaste._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".expectPaste" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = stopListeningToCanvas._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".stopListeningToCanvas" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = disconnectMutationObserver._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".disconnectMutationObserver" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
        }
        var e$10 = numPendingRequests._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".numPendingRequests" + e$10.path,
                  message: e$10.message,
                  value: e$10.value
                }
              };
      }
      var e$11 = editingInCell._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".editingInCell" + e$11.path,
                message: e$11.message,
                value: e$11.value
              }
            };
    }
    var e$12 = sheets._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheets" + e$12.path,
              message: e$12.message,
              value: e$12.value
            }
          };
  }
  var e$13 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$13.path,
            message: e$13.message,
            value: e$13.value
          }
        };
}

function reasonToCheckUpdate_decode(decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ChangeEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ChangeEvent */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "EditingCellChanged" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* EditingCellChanged */0
                  };
          }
      case "PasteEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteEvent */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "PastedText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PastedText */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  if (typeof v === "number") {
    if (v === /* Initialize */0) {
      return ["Initialize"];
    } else {
      return ["DiscoveredGapiNotLoaded"];
    }
  }
  switch (v.TAG | 0) {
    case /* SharedEvent */0 :
        return [
                "SharedEvent",
                ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
              ];
    case /* BasicEventOnGoogleSheets */1 :
        return [
                "BasicEventOnGoogleSheets",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
              ];
    case /* DidPreventUserInteraction */2 :
        return [
                "DidPreventUserInteraction",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
              ];
    case /* DidAttachMutationObserver */3 :
        return [
                "DidAttachMutationObserver",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
              ];
    case /* MutationsObserved */4 :
        return [
                "MutationsObserved",
                Decco.arrayToJson(encoder_domMutationRecord, v._0)
              ];
    case /* DidStartListeningToCanvas */5 :
        return [
                "DidStartListeningToCanvas",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
              ];
    case /* CanvasDidFillText */6 :
        return [
                "CanvasDidFillText",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1),
                Decco.intToJson(v._2),
                Curry._1(encoder_domHtmlElement, v._3)
              ];
    case /* DiscoveredGoogleAuthMissing */7 :
        return [
                "DiscoveredGoogleAuthMissing",
                googleAuthCallback_encode(encoder_domEvent, v._0)
              ];
    case /* DidGetNewAuthToken */8 :
        return [
                "DidGetNewAuthToken",
                Decco.stringToJson(v._0)
              ];
    case /* DidFetchGoogleSheet */9 :
        return [
                "DidFetchGoogleSheet",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_encode, v._0)
              ];
    case /* GoogleSheetUpdate */10 :
        return [
                "GoogleSheetUpdate",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_encode, v._0),
                reasonToCheckUpdate_encode(encoder_domEvent, v._1),
                PendingCommandInfo$SmartcutsMacros.key_encode(v._2),
                Decco.intToJson(v._3),
                Decco.intToJson(v._4)
              ];
    case /* Fail */11 :
        return [
                "Fail",
                failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* Exit */12 :
        return [
                "Exit",
                exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    
  }
}

function listener_encode(encoder_domMutationRecord, v) {
  if (v) {
    return [
            "GoogleSheetsMutationObserverListener",
            Decco.arrayToJson(encoder_domMutationRecord, v._0)
          ];
  } else {
    return ["CanvasListener"];
  }
}

function sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* PreventUserInteraction */0 :
          return ["PreventUserInteraction"];
      case /* StartGoogleAuthFlow */1 :
          return ["StartGoogleAuthFlow"];
      case /* StartListeningToCanvas */2 :
          return ["StartListeningToCanvas"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Dispatch */0 :
          return [
                  "Dispatch",
                  event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
                ];
      case /* AllowUserInteraction */1 :
          return [
                  "AllowUserInteraction",
                  DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
      case /* FetchGoogleSheetData */2 :
          return [
                  "FetchGoogleSheetData",
                  Decco.stringToJson(v._0),
                  Decco.optionToJson(Decco.stringToJson, v._1)
                ];
      case /* SetupMutationObserver */3 :
          return [
                  "SetupMutationObserver",
                  Curry._1(encoder_domHtmlElement, v._0)
                ];
      case /* NotifyBgAboutPossibleCommand */4 :
          return [
                  "NotifyBgAboutPossibleCommand",
                  PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
                  Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v._1)
                ];
      case /* CheckForGoogleSheetUpdates */5 :
          return [
                  "CheckForGoogleSheetUpdates",
                  Decco.stringToJson(v._0),
                  reasonToCheckUpdate_encode(encoder_domEvent, v._1),
                  Decco.optionToJson(Decco.stringToJson, v._2),
                  PendingCommandInfo$SmartcutsMacros.key_encode(v._3),
                  Decco.intToJson(v._4),
                  Decco.intToJson(v._5)
                ];
      case /* StreamGoogleSheetsCommandsToBg */6 :
          var v2 = v._2;
          return [
                  "StreamGoogleSheetsCommandsToBg",
                  Decco.listToJson(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_encode, v._0),
                  CommandContext$SmartcutsMacros.commandContextLocal_encode(v._1),
                  [
                    PendingCommandInfo$SmartcutsMacros.key_encode(v2[0]),
                    Decco.intToJson(v2[1])
                  ]
                ];
      case /* TellBgThatKeyDoesNotGenerateCommand */7 :
          return [
                  "TellBgThatKeyDoesNotGenerateCommand",
                  PendingCommandInfo$SmartcutsMacros.key_encode(v._0)
                ];
      case /* DisconnectMutationObserver */8 :
          return [
                  "DisconnectMutationObserver",
                  DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
      case /* StopListeningToCanvas */9 :
          return [
                  "StopListeningToCanvas",
                  DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
      
    }
  }
}

function googleAuthCallback_encode(encoder_domEvent, v) {
  if (v.TAG === /* Cb_FetchGoogleSheetData */0) {
    return [
            "Cb_FetchGoogleSheetData",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "Cb_CheckForGoogleSheetUpdates",
            Decco.stringToJson(v._0),
            reasonToCheckUpdate_encode(encoder_domEvent, v._1),
            PendingCommandInfo$SmartcutsMacros.key_encode(v._2),
            Decco.intToJson(v._3)
          ];
  }
}

function reasonToCheckUpdate_encode(encoder_domEvent, v) {
  if (typeof v === "number") {
    return ["EditingCellChanged"];
  }
  switch (v.TAG | 0) {
    case /* PastedText */0 :
        return [
                "PastedText",
                Decco.stringToJson(v._0)
              ];
    case /* PasteEvent */1 :
        return [
                "PasteEvent",
                Curry._1(encoder_domEvent, v._0)
              ];
    case /* ChangeEvent */2 :
        return [
                "ChangeEvent",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return listener_encode(encoder_domMutationRecord, param);
              }), otherFailureReason_encode, v);
}

function state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AwaitingPendingRequestsToFinishAndExit" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = editingGoogleSheets_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
                  return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* AwaitingPendingRequestsToFinishAndExit */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "EditingGoogleSheets" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = editingGoogleSheets_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* EditingGoogleSheets */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Exited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
                  return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exited */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Exiting" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exiting */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$4 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Init" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Init */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function listener_decode(decoder_domMutationRecord, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CanvasListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CanvasListener */0
                  };
          }
      case "GoogleSheetsMutationObserverListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* GoogleSheetsMutationObserverListener */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventOnGoogleSheets" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventOnGoogleSheets */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CanvasDidFillText" :
          if (tagged.length !== 5) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 3));
          var match$4 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 4));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                if (match$4.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            TAG: /* CanvasDidFillText */6,
                            _0: match$1._0,
                            _1: match$2._0,
                            _2: match$3._0,
                            _3: match$4._0
                          }
                        };
                }
                var e$1 = match$4._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "DidAttachMutationObserver" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidAttachMutationObserver */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$5 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "DidFetchGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFetchGoogleSheet */9,
                      _0: v0$2._0
                    }
                  };
          }
          var e$6 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "DidGetNewAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidGetNewAuthToken */8,
                      _0: v0$3._0
                    }
                  };
          }
          var e$7 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "DidPreventUserInteraction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidPreventUserInteraction */2,
                      _0: v0$4._0
                    }
                  };
          }
          var e$8 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "DidStartListeningToCanvas" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidStartListeningToCanvas */5,
                      _0: v0$5._0
                    }
                  };
          }
          var e$9 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "DiscoveredGapiNotLoaded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DiscoveredGapiNotLoaded */1
                  };
          }
      case "DiscoveredGoogleAuthMissing" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = googleAuthCallback_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DiscoveredGoogleAuthMissing */7,
                      _0: v0$6._0
                    }
                  };
          }
          var e$10 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exit */12,
                      _0: v0$7._0
                    }
                  };
          }
          var e$11 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */11,
                      _0: v0$8._0
                    }
                  };
          }
          var e$12 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "GoogleSheetUpdate" :
          if (tagged.length !== 6) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = reasonToCheckUpdate_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 2));
          var match$7 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 3));
          var match$8 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 4));
          var match$9 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 5));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              if (match$7.TAG === /* Ok */0) {
                if (match$8.TAG === /* Ok */0) {
                  if (match$9.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              TAG: /* GoogleSheetUpdate */10,
                              _0: match$5._0,
                              _1: match$6._0,
                              _2: match$7._0,
                              _3: match$8._0,
                              _4: match$9._0
                            }
                          };
                  }
                  var e$13 = match$9._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[4]" + e$13.path,
                            message: e$13.message,
                            value: e$13.value
                          }
                        };
                }
                var e$14 = match$8._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e$14.path,
                          message: e$14.message,
                          value: e$14.value
                        }
                      };
              }
              var e$15 = match$7._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                      }
                    };
            }
            var e$16 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Initialize */0
                  };
          }
      case "MutationsObserved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MutationsObserved */4,
                      _0: v0$9._0
                    }
                  };
          }
          var e$18 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "SharedEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SharedEvent */0,
                      _0: v0$10._0
                    }
                  };
          }
          var e$19 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AllowUserInteraction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AllowUserInteraction */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CheckForGoogleSheetUpdates" :
          if (tagged.length !== 7) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = reasonToCheckUpdate_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Decco.optionFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 3));
          var match$4 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 4));
          var match$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 5));
          var match$6 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 6));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                if (match$4.TAG === /* Ok */0) {
                  if (match$5.TAG === /* Ok */0) {
                    if (match$6.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                TAG: /* CheckForGoogleSheetUpdates */5,
                                _0: match$1._0,
                                _1: match$2._0,
                                _2: match$3._0,
                                _3: match$4._0,
                                _4: match$5._0,
                                _5: match$6._0
                              }
                            };
                    }
                    var e$1 = match$6._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[5]" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = match$5._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[4]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = match$4._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "DisconnectMutationObserver" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DisconnectMutationObserver */8,
                      _0: v0$1._0
                    }
                  };
          }
          var e$7 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$8 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "FetchGoogleSheetData" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = Decco.optionFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FetchGoogleSheetData */2,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$9 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "NotifyBgAboutPossibleCommand" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* NotifyBgAboutPossibleCommand */4,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$11 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "PreventUserInteraction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PreventUserInteraction */0
                  };
          }
      case "SetupMutationObserver" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SetupMutationObserver */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$13 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "StartGoogleAuthFlow" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* StartGoogleAuthFlow */1
                  };
          }
      case "StartListeningToCanvas" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* StartListeningToCanvas */2
                  };
          }
      case "StopListeningToCanvas" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* StopListeningToCanvas */9,
                      _0: v0$4._0
                    }
                  };
          }
          var e$14 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "StreamGoogleSheetsCommandsToBg" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$11 = Decco.listFromJson(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$12 = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Array.getExn(jsonArr$1, 2));
          var json = Belt_Array.getExn(jsonArr$1, 3);
          var match$13 = Js_json.classify(json);
          var match$14;
          if (typeof match$13 === "number" || match$13.TAG !== /* JSONArray */3) {
            match$14 = Decco.error(undefined, "Not a tuple", json);
          } else {
            var match$15 = match$13._0;
            if (match$15.length !== 2) {
              match$14 = Decco.error(undefined, "Incorrect cardinality", json);
            } else {
              var v0$5 = match$15[0];
              var v1 = match$15[1];
              var match$16 = PendingCommandInfo$SmartcutsMacros.key_decode(v0$5);
              var match$17 = Decco.intFromJson(v1);
              if (match$16.TAG === /* Ok */0) {
                if (match$17.TAG === /* Ok */0) {
                  match$14 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$16._0,
                      match$17._0
                    ]
                  };
                } else {
                  var e$15 = match$17._0;
                  match$14 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$15.path,
                      message: e$15.message,
                      value: e$15.value
                    }
                  };
                }
              } else {
                var e$16 = match$16._0;
                match$14 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
              }
            }
          }
          if (match$11.TAG === /* Ok */0) {
            if (match$12.TAG === /* Ok */0) {
              if (match$14.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* StreamGoogleSheetsCommandsToBg */6,
                          _0: match$11._0,
                          _1: match$12._0,
                          _2: match$14._0
                        }
                      };
              }
              var e$17 = match$14._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                      }
                    };
            }
            var e$18 = match$12._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$18.path,
                      message: e$18.message,
                      value: e$18.value
                    }
                  };
          }
          var e$19 = match$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "TellBgThatKeyDoesNotGenerateCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TellBgThatKeyDoesNotGenerateCommand */7,
                      _0: v0$6._0
                    }
                  };
          }
          var e$20 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function googleAuthCallback_decode(decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Cb_CheckForGoogleSheetUpdates" :
          if (tagged.length !== 5) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = reasonToCheckUpdate_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 3));
          var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 4));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                if (match$4.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            TAG: /* Cb_CheckForGoogleSheetUpdates */1,
                            _0: match$1._0,
                            _1: match$2._0,
                            _2: match$3._0,
                            _3: match$4._0
                          }
                        };
                }
                var e = match$4._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Cb_FetchGoogleSheetData" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Cb_FetchGoogleSheetData */0,
                      _0: v0._0
                    }
                  };
          }
          var e$4 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return listener_encode(encoder_domMutationRecord, param);
              }), otherFailureReason_encode, v);
}

function failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

function exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Js_dict.fromArray([[
                "allExitReasons",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                      }), v.allExitReasons)
              ]]);
}

function editingGoogleSheets_encode(encoder_domEvent, v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheets",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_encode, v.sheets)
              ],
              [
                "editingInCell",
                Decco.optionToJson(Decco.stringToJson, v.editingInCell)
              ],
              [
                "numPendingRequests",
                Decco.intToJson(v.numPendingRequests)
              ],
              [
                "disconnectMutationObserver",
                Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.disconnectMutationObserver)
              ],
              [
                "stopListeningToCanvas",
                Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.stopListeningToCanvas)
              ],
              [
                "expectPaste",
                Decco.optionToJson(Decco.stringToJson, v.expectPaste)
              ],
              [
                "googleAuthCallback",
                Decco.optionToJson((function (param) {
                        return googleAuthCallback_encode(encoder_domEvent, param);
                      }), v.googleAuthCallback)
              ],
              [
                "removeListenersPreventingUserInteraction",
                Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.removeListenersPreventingUserInteraction)
              ],
              [
                "sheetUpdateTriggerCount",
                Decco.intToJson(v.sheetUpdateTriggerCount)
              ],
              [
                "mostRecentTriggerThatReceivedSheetUpdate",
                Decco.optionToJson(Decco.intToJson, v.mostRecentTriggerThatReceivedSheetUpdate)
              ],
              [
                "rectForCommandKey",
                CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(Rect$SmartcutsMacros.t_encode, v.rectForCommandKey)
              ],
              [
                "expectCellValue",
                Decco.optionToJson(Decco.stringToJson, v.expectCellValue)
              ],
              [
                "pendingCommandKey",
                Decco.optionToJson(PendingCommandInfo$SmartcutsMacros.key_encode, v.pendingCommandKey)
              ]
            ]);
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

function errorContext_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return listener_encode(encoder_domMutationRecord, param);
              }), v);
}

function errorContext_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), v);
}

var Generic = {
  state_encode: state_encode,
  state_decode: state_decode,
  googleAuthCallback_encode: googleAuthCallback_encode,
  googleAuthCallback_decode: googleAuthCallback_decode,
  editingGoogleSheets_encode: editingGoogleSheets_encode,
  editingGoogleSheets_decode: editingGoogleSheets_decode,
  exiting_encode: exiting_encode,
  exiting_decode: exiting_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  reasonToCheckUpdate_encode: reasonToCheckUpdate_encode,
  reasonToCheckUpdate_decode: reasonToCheckUpdate_decode,
  listener_encode: listener_encode,
  listener_decode: listener_decode,
  failure_encode: failure_encode,
  failure_decode: failure_decode,
  otherFailureReason_encode: otherFailureReason_encode,
  otherFailureReason_decode: otherFailureReason_decode,
  errorContext_encode: errorContext_encode,
  errorContext_decode: errorContext_decode,
  exitReason_encode: exitReason_encode,
  exitReason_decode: exitReason_decode
};

var Regular = {};

var ForSerialization = {};

exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* Rect-SmartcutsMacros Not a pure module */
